import axios, { AxiosResponse } from 'axios';
import { saveBlob } from './saveBlob';
import { parseContentDispositionFilename } from './contentDisposition';

/** A blob request turns the server's JSON error into a Blob: read its message back so the toast is useful. */
const unwrapBlobError = async (error: any): Promise<never> => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      if (parsed && typeof parsed.message === 'string') error.response.data = parsed;
    } catch {
      // not JSON: keep the original error
    }
  }
  throw error;
};

const save = (response: AxiosResponse, fallbackName: string): void => {
  const disposition: string = response.headers?.['content-disposition'] ?? '';
  saveBlob(new Blob([response.data]), parseContentDispositionFilename(disposition, fallbackName));
};

/** GET a file from the API and save it with the server's file name. */
export const downloadGet = async (
  url: string, params: Record<string, string | undefined> | undefined, fallbackName: string,
): Promise<void> => {
  try {
    save(await axios.get(url, { params, responseType: 'blob' }), fallbackName);
  } catch (error) {
    await unwrapBlobError(error);
  }
};

/** POST a JSON body to the API and save the file that comes back. */
export const downloadPost = async (url: string, body: unknown, fallbackName: string): Promise<void> => {
  try {
    save(await axios.post(url, body, { responseType: 'blob' }), fallbackName);
  } catch (error) {
    await unwrapBlobError(error);
  }
};
